/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaChiusuraScolasticaUpdateForm { 
    data: string;
    classe?: string;
    sezione?: string;
    motivazione?: string;
}

